/* unplugin-vue-components disabled */import { render } from "./DialogSearch.vue?vue&type=template&id=47109c96&scoped=true"
import script from "./DialogSearch.vue?vue&type=script&lang=js"
export * from "./DialogSearch.vue?vue&type=script&lang=js"

import "./DialogSearch.vue?vue&type=style&index=0&id=47109c96&lang=scss&scoped=true"

import exportComponent from "C:\\prj\\tbumz\\bumz-support-bot\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47109c96"]])

export default __exports__